/*
 * Beagletuff: Die Produktgalerie startet ohne gewählte Variante mit dem ersten Produktbild
 * (snippets/product-gallery.liquid). Die vorausgewählte Farbe ist dann zwar markiert, ein Klick
 * darauf löst aber kein "change" aus. Dieses Skript zeigt bei einem Klick auf die bereits
 * gewählte Option das Bild dieser Variante.
 */
(() => {
  if (window.btFarbeErneut) return;
  window.btFarbeErneut = true;

  document.addEventListener('click', (event) => {
    const label = event.target.closest('label[for]');
    if (!label) return;

    const input = document.getElementById(label.htmlFor);
    // Nur die bereits gewählte Option: bei allen anderen sorgt der Variantenwechsel des Themes selbst für das Bild
    if (!input || !input.matches('input[data-option-position]') || !input.checked) return;

    const formId = input.getAttribute('form');
    const form = document.forms[formId];
    const picker = document.querySelector(`variant-picker[form-id="${formId}"]`);
    const variant = picker?.selectedVariant;
    if (!form || !variant || !variant.featured_media) return;

    form.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { formId: form.id, variant, previousVariant: null }
    }));
  });
})();
